import urlJoin from 'url-join';
import { AppSettings } from 'core/AppSettings';

const HUB_SOURCE_PARAM = 'ideagen_hub_source';
const AUTHENTICATION_PATH = '/security/login';
const RETURN_URL_PARAM = 'ReturnUrl';

export function getLoginRedirectUrl(): string {
  const returnUrl = getReturnUrl();
  return hasFacilityContext(returnUrl) ? getAuthenticationUrl(returnUrl) : getLoginPageUrl();
}

export function getAuthenticationUrl(returnUrl: URL = getReturnUrl()): string {
  const encoded = encodeURIComponent(returnUrl.href);
  return `${urlJoin(getApiHost(), AUTHENTICATION_PATH)}?${RETURN_URL_PARAM}=${encoded}`;
}

export function getLoginPageUrl(): string {
  return urlJoin(AppSettings.authUrl, `?${RETURN_URL_PARAM}=${encodeURI(AppSettings.omnisUrl)}`);
}

function getReturnUrl(): URL {
  const url = new URL(window.location.href);
  url.searchParams.delete(HUB_SOURCE_PARAM);
  url.search = url.searchParams.toString();
  return url;
}

function hasFacilityContext(returnUrl: URL): boolean {
  return returnUrl.pathname.split('/').filter(Boolean).length >= 2;
}

function getApiHost(): string {
  const host = AppSettings.cumulusApiUrl;
  if (host.startsWith('/')) return `${window.location.origin}${host}`;
  return host.startsWith('http') ? host : `https://${host}`;
}
